import { createAsyncThunk } from "@reduxjs/toolkit";
import { BasketApiImpl } from "../../basket/api/BasketApi";

export const getSaturdayDeliveryUsabilityThunk = createAsyncThunk(
  "orders/saturday-delivery-product",
  () => {
    return BasketApiImpl.getInstance().getSaturdayDeliveryProductIfApplicable();
  }
);
